const DropDown = ({ id, direction, options, onSelect, buttonStyle, maxHeight }: {
  onSelect: (option: string) => void
  id?: string
  options: string[]
  direction?: 'top' | 'bottom' | 'right' | 'left'
  maxHeight?: string | number
  buttonStyle?: React.CSSProperties
}) => {
  return (
    <div id={id} className={`z-20 overflow-auto absolute ${direction === 'top' ? 'bottom-full mb-1' : 'top-full mt-1'} left-0 w-full bg-white border rounded-lg shadow`} style={{ maxHeight: maxHeight }}>
      {options.map(option => (
        <button onClick={() => onSelect(option)} className='scale-none p-1 text-xs md:text-sm px-2 hover:bg-primary/10 w-full' style={buttonStyle || {}}>{option}</button>
      ))}
    </div>
  )
}

export default DropDown